import { h, render, reactive } from 'vue'
import Toast from './index.vue'

export default {
  install (app) {
    const state = reactive({
      toasts: []
    })

    const dynamicDuration = (message) => {
      return Math.max(3, Math.min(message.length / 16 + 2, 6)) * 1000
    }

    const showToast = (message, options = {}) => {
      const id = Date.now()
      state.toasts.push({ id, message, ...options })

      // 自动移除 toast
      setTimeout(() => {
        state.toasts = state.toasts.filter((toast) => toast.id !== id)
      }, options.duration || dynamicDuration(message))
    }

    const mountToastComponent = () => {
      const div = document.createElement('div')
      document.body.appendChild(div)

      const vnode = h(Toast, { state })
      render(vnode, div)
    }

    // 提供全局方法
    app.config.globalProperties.$toast = showToast

    mountToastComponent()
  }
}
